import { render } from "./VerPreguntas.vue?vue&type=template&id=62b498d8"
import script from "./VerPreguntas.vue?vue&type=script&lang=js"
export * from "./VerPreguntas.vue?vue&type=script&lang=js"

import "./VerPreguntas.vue?vue&type=style&index=0&id=62b498d8&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__